module.exports = __webpack_public_path__ + "assets/img/7143f9d7660fed4ad4f82556bedd4f81.svg";